/**
 * Яндекс.Метрика, счётчик 106216003.
 *
 * Раньше подключалась тегом в <head> и стартовала до любого действия
 * посетителя. С 24.08.2026 загружается только после явного согласия —
 * см. useCookieConsent. Вебвизор отключён намеренно: он записывал ввод
 * в поля формы, которая сама никуда ничего не отправляет.
 */

export const METRIKA_ID = 106216003

const TAG_SRC = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`

type YmFn = ((...args: unknown[]) => void) & { a?: unknown[]; l?: number }

declare global {
  interface Window {
    ym?: YmFn
  }
}

let started = false

/**
 * Подключает тег Метрики и инициализирует счётчик.
 * Повторные вызовы игнорируются.
 */
export function initMetrika(): void {
  if (started || typeof window === 'undefined') return
  if (document.querySelector(`script[src="${TAG_SRC}"]`)) return
  started = true

  // Очередь вызовов до загрузки тега — тот же приём, что в оригинальном
  // сниппете Яндекса: ym() можно звать сразу, аргументы накопятся в ym.a
  const ym: YmFn = function (...args: unknown[]) {
    ;(ym.a = ym.a || []).push(args)
  }
  ym.l = Date.now()
  window.ym = window.ym || ym

  const script = document.createElement('script')
  script.async = true
  script.src = TAG_SRC
  document.head.appendChild(script)

  window.ym(METRIKA_ID, 'init', {
    ssr: true,
    webvisor: false,
    clickmap: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    trackLinks: true,
  })
}

/**
 * Хит при смене маршрута. В SPA переход не перезагружает документ,
 * поэтому Метрика сама его не заметит.
 */
export function trackPageView(url: string): void {
  if (!started || !window.ym) return
  window.ym(METRIKA_ID, 'hit', url)
}

/**
 * Удаляет cookie Метрики. Вызывается при отзыве согласия — сам счётчик
 * в этой вкладке уже не остановить, но новые визиты будут чистыми.
 */
export function clearMetrikaCookies(): void {
  if (typeof document === 'undefined') return
  const host = window.location.hostname
  const domains = [host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`]

  document.cookie.split(';').forEach(entry => {
    const name = entry.split('=')[0]?.trim()
    if (!name || !name.startsWith('_ym')) return
    domains.forEach(domain => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`
    })
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  })
}
